export default __webpack_public_path__ + "static/iot_banner-04acecc92cdd03badb1a8e082e8b4009.png";